var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "star_svg__block star_svg__size-full",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 .5 2.8 8.7 8.6.8-6 5.4 1.4 8.6-6.8-4-6.8 4 1.4-8.6-6-5.4 8.6-.8L12 .5Z",
  clipRule: "evenodd"
})));
SvgStar.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export default ForwardRef;